import ApiFragmentDto from "./ApiFragmentDto";

export default class CustomerFragmentDto {

    CustomerFragmentId: number;
    Fragment: string;
    ApiFragments: ApiFragmentDto[];

    constructor(customerFragmentId: number, fragment: string, apiFragments: ApiFragmentDto[]) {
        this.CustomerFragmentId = customerFragmentId;
        this.Fragment = fragment;
        this.ApiFragments = apiFragments;
    }
}